// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export function getGlobalObject(): any {
  return global;
}
